module.exports = __webpack_public_path__ + "static/media/communion1.2a51ae6a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/communion1.pdf
// module id = 785
// module chunks = 2